import EventTracker from '~/js/components/event_tracker';

window.SiteConfig = window.SiteConfig || {};
window.SK = window.SK || {};

const tracker = new EventTracker({
  ...window.SiteConfig.EventTracker,
  props: window._sktrk || [],
});

// It must be initialized after the global variable assignment.
window.SK.EventTracking = tracker;
tracker.init();

SK?.Helpers?.vent?.on('sk_special_offer:modal:track', (event) => {
  const type = event.type; // 'Viewed' || 'Closed'
  const name = event.name; // Name of the special offer
  const variant = event.variant; // Variant of the special offer

  if (type === 'Viewed') {
    tracker.setUserProperty('specialOffer', name);
    tracker.increment('specialOfferCount');
    tracker.track('Feature: Special Offer Modal', {
      sourceUrl: window.location.pathname,
      offerName: name,
      offerVariant: variant
    });
  }
});
